var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconKeyboard = function SvgIconKeyboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.953 4.25c.992 0 1.797.804 1.797 1.797v11.906c0 .992-.805 1.797-1.797 1.797H3.047a1.797 1.797 0 0 1-1.797-1.797V6.047c0-.993.804-1.797 1.797-1.797zM3.25 17.75h17.5V6.25H3.25zm3.5-3.375a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2zm7.125 0a1 1 0 1 1 0 2h-3.75a1 1 0 1 1 0-2zm4.125 0a1 1 0 1 1 0 2h-.75a1 1 0 1 1 0-2zM18 11a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2zm0-3.375a1 1 0 1 1 0 2H6a1 1 0 0 1 0-2z"
  })));
};
export default SvgIconKeyboard;